import DI from '@/interface';

// cookie.expiresMultiplier = 60; // 设置cookie有效期为分钟.

const AGENT = navigator.userAgent;
window.pptvConfig = false;

export default {
  data () {
    return {
      isIOS: /(iPhone|iPod|iPad|iOS)/i.test(AGENT),
      isPPSPORTS: /pptvsports/i.test(AGENT),
      isPPTV: /pptv/i.test(AGENT) && !/pptvsports/i.test(AGENT),
      isWX: /MicroMessenger/i.test(AGENT),
      isHUAWEI: /HUAWEI/i.test(AGENT),
      isAndroid: /(Android|Adr)/i.test(AGENT),
      userinfo: {
        username: '',
        token: '',
        nickname: '',
        avatar: '',
        appplt: this.isIOS ? 'iph' : 'aph',
        appid: this.isIOS ? 'pptv.iphone.sports' : 'pptv.aphone.sports',
        appver: '5.3.2',
        appverNum: '532'
      },
      urlinfo: {},
      shareMsg: {}, //分享信息
      shareWxMsg: {}, //微信分享信息
      isPc: false, //是否是pc标识
      isIOSLiuHaiPing: false,
    };
  },
  created () {
    // this.loadCookie();
    this.isIOSLiuHaiPing = this.judgeIsIOSLiuHaiPing();
  },
  methods: {
    loadCookie () {
      if (this.isPPSPORTS) {
        if (/cookieStr\=([\s\S]*)complete/.test(AGENT)) {
          const cookieStr = AGENT.match(/cookieStr\=([\s\S]*)complete/)[1];
          cookieStr.split(" ").forEach(item => {
            document.cookie = item;
          });
        }
      }
    },
    judgeIsIOSLiuHaiPing () {
      if (typeof window !== 'undefined' && window) {
        return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
      }
      return false;
    },
    extInfo (obj) {
      return JSON.stringify(obj);
    },
    /*
    * @method sendMsg
    * @todo pcLog发送错误消息
    * 
    */
    sendMsg (params) {
      setTimeout(() => {
        try {
          if (window.sa && window.sa.openAPI && window.sa.openAPI.sendMsgV2 && location.href.indexOf('isports') > -1) {
            window.sa.openAPI.sendMsgV2(params);
          }
        } catch (err) {}
      }, 500)
    },
    /*
    * @method getUrlArgs
    * @todo url?后参数对象化 支持#/路由形式
    * @param  null
    * @return { object } 
    */
    getUrlArgs () {
      let lsUrl = location.href.replace('=','');
      const query = (decodeURIComponent(lsUrl)).split('?')[1];
      const query3 = (decodeURIComponent(lsUrl)).split('?')[2];
      const query2 = query ? query.replace(/#\//, '') : '';
      const query4 = query3 ? query3.replace(/#\//, '') : '';
      const pairs = query2.split('&');
      const pairs2 = query4.split('&');
      let args = {};
      let pos;
      let idx;
      let argname;
      let val;
      for (var i = 0; i < pairs.length; i++) {
        pos = pairs[i];
        idx = pos.indexOf('=');
        if (idx == -1) continue;
        argname = pos.substring(0, idx);
        val = decodeURIComponent(pos.substring(idx + 1));
        args[argname] = val;
      }
      for (var i = 0; i < pairs2.length; i++) {
        pos = pairs2[i];
        idx = pos.indexOf('=');
        if (idx == -1) continue;
        argname = pos.substring(0, idx);
        val = decodeURIComponent(pos.substring(idx + 1));
        args[argname] = val;
      }
      return args;
    },
    /*
      curVer: 当前版本号，如'5.6.6'
      targetVer: 待比较版本号，如'5.9'
      return Boolen，当前版本号大于等于待比较版本号
    */
    rtVersion (curVer = '', targetVer = '') {
      const curVerArr = curVer.split('.');
      const targetVerArr = targetVer.split('.');
      curVerArr.length < 3 && curVerArr.push(0);
      targetVerArr.length < 3 && targetVerArr.push(0);
      if (+curVerArr[0] === +targetVerArr[0]) {
        if (+curVerArr[1] === +targetVerArr[1]) {
          return +curVerArr[2] >= +targetVerArr[2];
        } else {
          return +curVerArr[1] > +targetVerArr[1];
        }
      } else {
        return +curVerArr[0] > +targetVerArr[0];
      }
    },
    /*
    * @method getAppverNum
    * @todo  app版本数字化
    * @param { string } ver 当前app版本
    * @return null
    */
    getAppverNum (ver = '') {
      let appver = '';
      const appverArr = ver.split('.');
      if (appverArr.length === 1) {
        appverArr.push('0', '0');
      } else if (appverArr.length === 2) {
        appverArr.push('0');
      }
      // eslint-disable-next-line no-return-assign
      appverArr.map(cur => appver += cur);

      return Number(appver);
    },
    getLocationSearch(obj) {
      const queryObj = obj;
      delete queryObj.openid;
      delete queryObj.unionid;
      delete queryObj.wx_access_token;
      delete queryObj.wx_refresh_token;
      delete queryObj.username;
      delete queryObj.token;
      delete queryObj.errorCode;
      delete queryObj.msg;
      let url = location.origin + location.pathname;
      if (Object.keys(queryObj).length > 0) {
        const str = JSON.stringify(queryObj);
        url += `?${str.replace(/"|{|}/g, '').replace(/:/g, '=').replace(/,/g, '&')}`;
      }
      return url;
    },
    /*
    * @method getUserInfo
    * @todo  统一获取用户信息
    * @param { function } callback 回调
    * @return null
    */
    getUserInfo (callback) {
      this.urlinfo = this.getUrlArgs();
      // eslint-disable-next-line no-undef
      const appverNum = this.getAppverNum(cookie.get('appver'));

      // eslint-disable-next-line no-undef
      if (this.isPPSPORTS) {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const userinfo = {};
        // eslint-disable-next-line no-undef
        ppsport.getUserInfo({
          success (info) {
            userinfo.username = (decodeURIComponent(info.username) && decodeURIComponent(info.username)!= 'undefined') ? decodeURIComponent(info.username) : '';
            userinfo.token = (decodeURIComponent(info.token) && decodeURIComponent(info.token) != 'undefined') ? decodeURIComponent(info.token) : '';
            userinfo.nickname = info.nickname;
            userinfo.avatar = info.headico;
            // eslint-disable-next-line prefer-destructuring
            userinfo.appver = info.version.split('_')[1];
            userinfo.appverNum = _this.getAppverNum(info.version.split('_')[1]);
            // eslint-disable-next-line no-undef
            userinfo.appid = cookie.get('appid') || (this.isIOS ? 'pptv.iphone.sports' : 'pptv.aphone.sports');
            // eslint-disable-next-line no-undef
            userinfo.appplt = cookie.get('appplt') || (this.isIOS ? 'iph' : 'aph');

            Object.assign(_this.userinfo, userinfo);
            if (typeof callback === 'function') callback();
          },
          error () {
          },
        });
      } else if (this.isWX) {
        if (location.href.indexOf('invite') > -1) {
          const ppuser = cookie.get('ppuser');
          this.userinfo = Object.assign(this.userinfo, JSON.parse(ppuser));
        } else {
          ppsportsLogin.wx.getUserData((userinfo) => {
            this.userinfo = Object.assign(this.userinfo, userinfo);
            if (typeof callback === 'function') callback();
          }, 'wxcb72890beaed4661');
        }
      } else {
        let userinfo = cookie.get(['username', 'token', 'ppToken', 'nickname', 'avatar', 'appplt', 'appid', 'appver', 'openid', 'wx_access_token', 'wx_refresh_token']);
        if(userinfo.username && userinfo.token){
          userinfo.appverNum = appverNum;
          !userinfo.appver && delete userinfo.appver;
          !userinfo.appplt && delete userinfo.appplt;
          !userinfo.appid && delete userinfo.appid;
        }
        Object.assign(this.userinfo, userinfo);
        if (typeof callback === 'function') callback();
      }
    },
    /*
    * @method createBridge
    * @todo  ios jsbridge方式调用原生方法封装
    * @param { string } opt
    * @return null
    */
    createBridge (opt) {
      const url = 'jsbridge://doAction?' + opt;
      var iframe = document.createElement('iframe');
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.display = 'none';
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(function () {
        iframe.remove();
      }, 100);
    },
    /*
    * @method login
    * @todo  统一登录配置
    * @param 
    * @return null
    */
    login () {
      try {
        if (this.isPPTV) {
          ppsdk.ready(function () {
            ppsdk.login({
              autologin: false,
              success: function () {
                location.reload();
              }
            });
          });
        } else if (this.isPPSPORTS) {
          if (this.isIOS) {
            this.createBridge('needlogin');
          } else {
            football.goLogin();
          }
        } else if(this.isWX) {
          ppsportsLogin.wx.doLogin('wxcb72890beaed4661');
        } else {
          //兼容IE
          if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
          }
          const origin = location.origin;
          //环境判断
          if (origin.indexOf('dev') > -1 || origin.indexOf('sit') > -1 || origin.indexOf('pre') > -1) {
            location.href = '/login/login.html?targetUrl=' + encodeURIComponent(location.href);
          } else {
            location.href = ('https:' == document.location.protocol ? 'https:' : 'http:') + '//ppsports.suning.com/login/login.html?targetUrl=' + encodeURIComponent(location.href);
          }
        }
      } catch (error) {
        console.log('请在app内打开');
      }
    },
    /*
    * @method ajax
    * @todo ajax统一配置
    * @param  ｛ object ｝配置项定制化
    * @return null
    */
    ajax (options, showErr) {
      let opt = {};
      let baseOpt = {
        beforeSend () {
          this.$loading();
        },
        error (err) {
          this.$loadingerr();
        },
        complete () {
          this.$loadingHide();
        },
        timeout: 5000,
      };
      Object.assign(opt, baseOpt, options);
      $.ajax(opt);
      // let authStatusOpt = {
      //   type: 'GET',
      //   url: DI.authStatus,
      //   context: this,
      //   dataType: 'jsonp',
      //   success (res) {
      //     if (res.hasLogin) {
            // $.ajax(opt);
      //     } else {
      //       this.$toast("登录超时，请重新访问页面");
      //     }
      //   },
      // };
      // Object.assign(authStatusOpt, baseOpt);
      // $.ajax(authStatusOpt);


      
      /* $.ajax({
        type: 'GET',
        url: DI.authStatus,
        context: this,
        dataType: 'jsonp',
        beforeSend () {
          this.$loading();
        },
        success (res) {
          if (res.hasLogin) {
            
          } else {
            this.$toast("登录超时，请重新访问页面");
          }
        },
        complete () {
          this.$loadingHide();
        },
      }); */

      
      // $.ajax(opt);
    },
    /*
    * @method pageShare
    * @todo 微信分享 + PP体育分享
    * @param  null
    * @return null
    */
    pageShare (cb) {
      const _that = this;
      if (this.isPPSPORTS) {
       window.webShareMessages = function () {
          return JSON.stringify({ 
            link: _that.shareMsg.link,
            image: _that.shareMsg.image,
            title: _that.shareMsg.title,
            describe: _that.shareMsg.describe
          });
        }
      } else if (this.isWX) {
        $.ajax({
          url: DI.getWXSign,
          data: {
            url: location.href
          },
          dataType: 'jsonp',
          success: function(data) {
            wx.config({
              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo'
              ]
            });
            wx.ready(function() {
              var shareinfo = {
                link: _that.shareMsg.link,
                imgUrl: _that.shareMsg.image,
                title: _that.shareMsg.title,
                desc: _that.shareMsg.describe,
                success: function() {
                }
              }
              wx.onMenuShareAppMessage(shareinfo);
              wx.onMenuShareTimeline(shareinfo);
              wx.onMenuShareQQ(shareinfo);
              wx.onMenuShareWeibo(shareinfo);
            });
            if (cb) cb();
          }
        });
      }
    },

    // 加载脚本
    getScript (src, func) {
      var script = document.createElement('script');
      script.async = "async";
      script.src = src;
      if (func) {
        script.onload = func;
      }
      document.head.appendChild(script);
    },

  },
  mounted () {
    // 页面默认白屏loading关闭，展示页面
    window.removeLoading();
  }
};
